import { INIT } from 'client/constants';
import { getSettings, getCategories, getItems } from 'admin/actions';
import _ from 'lodash';

export function init() {
	return async (dispatch, getState) => {
		try {
			dispatch({ type: INIT.START });

			await Promise.all([dispatch(getSettings()), dispatch(getCategories())]);
			await dispatch(getItems(_.get(getState(), 'categories.data.podcasts.id', '')));

			dispatch({ type: INIT.SUCCESS });
		} catch (e) {
			dispatch({ type: INIT.FAIL });
		}
	};
}
